<template>

  <div class="editor-warp">

    <el-dialog title="个人客户信息" :append-to-body="append_to_body" :visible.sync="personalEditorVisable" :close-on-click-modal="false" top="5vh" width="1200px">
      <el-tabs v-model="personalTabIndex" type="card">
        <el-tab-pane label="客户信息" name="personal-basic-editor"></el-tab-pane>
        <el-tab-pane label="详细信息" name="personal-extend-editor" v-if="id"></el-tab-pane>
        <el-tab-pane label="家庭档案" name="family-document-editor" v-if="id>0"></el-tab-pane>
        <el-tab-pane label="其它信息" name="other-editor" v-if="id>0"></el-tab-pane>
        <el-tab-pane label="财务信息" name="finance-list" v-if="id>0"></el-tab-pane>
        <el-tab-pane label="欠费原因" name="reason-list" v-if="id>0"></el-tab-pane>
        <el-tab-pane label="报事报修" name="report-repairs" v-if="id>0"></el-tab-pane>
        <el-tab-pane label="兴趣爱好" name="interest-editor" v-if="id>0"></el-tab-pane>
<!--        <el-tab-pane label="事务信息" name="affairs-editor" v-if="id>0"></el-tab-pane>-->
<!--        <el-tab-pane label="服务信息" name="serve-editor"></el-tab-pane>-->
<!--        <el-tab-pane label="投诉信息" name="complaint-editor" v-if="id>0"></el-tab-pane>-->
<!--        <el-tab-pane label="咨询建议" name="consultation-editor" v-if="id>0"></el-tab-pane>-->
<!--        <el-tab-pane label="发函管理" name="message-management-editor" v-if="id>0"></el-tab-pane>-->
<!--        <el-tab-pane label="管家记事" name="butler-note-editor" v-if="id>0"></el-tab-pane>-->
      </el-tabs>
      <component :is_edit="is_edit" v-bind:is="personalTabIndex" v-model="personalEditorVisable" :id="id" :cclass="1" @callback="callback(arguments)"></component>
    </el-dialog>

    <el-dialog title="企业客户信息" :visible.sync="enterpriseEditorVisable" :close-on-click-modal="false" top="5vh" width="1200px">
      <el-tabs v-model="enterpriseTabIndex" type="card">
        <el-tab-pane label="客户信息" name="enterprise-editor"></el-tab-pane>
<!--        <el-tab-pane label="家庭档案" name="family-document-editor" v-if="id>0"></el-tab-pane>-->
<!--        <el-tab-pane label="其它信息" name="other-editor" v-if="id>0"></el-tab-pane>-->
<!--        <el-tab-pane label="财务信息" name="finance-editor" v-if="id>0"></el-tab-pane>-->
        <el-tab-pane label="财务信息" name="finance-list" v-if="id>0"></el-tab-pane>
        <el-tab-pane label="欠费原因" name="reason-list" v-if="id>0"></el-tab-pane>
        <el-tab-pane label="报事报修" name="report-repairs" v-if="id>0"></el-tab-pane>
        <el-tab-pane label="兴趣爱好" name="interest-editor" v-if="id>0"></el-tab-pane>
<!--        <el-tab-pane label="事务信息" name="affairs-editor" v-if="id>0"></el-tab-pane>-->
<!--        <el-tab-pane label="投诉信息" name="complaint-editor" v-if="id>0"></el-tab-pane>-->
<!--        <el-tab-pane label="咨询建议" name="consultation-editor" v-if="id>0"></el-tab-pane>-->
<!--        <el-tab-pane label="发函管理" name="message-management-editor" v-if="id>0"></el-tab-pane>-->
<!--        <el-tab-pane label="管家记事" name="butler-note-editor" v-if="id>0"></el-tab-pane>-->
      </el-tabs>
      <component :is_edit="is_edit" v-bind:is="enterpriseTabIndex" v-model="enterpriseEditorVisable" :id="id" :cclass="2" @callback="callback(arguments)"></component>
    </el-dialog>

  </div>

</template>

<script>
  import Common from './common.js'

  export default {
    name: "editor",
    emits: ['input'],
    props: {
      value: {
        type: Boolean,
        default() {
          return false
        }
      },
      id: {
        type: [String, Number],
        default() {
          return 0
        }
      },
      classValue: {
        type: [String, Number],
        default() {
          return 0
        }
      },
      is_edit:{
        type: Boolean,
        default() {
          return true
        }
      },
      append_to_body:{
        type: Boolean,
        default() {
          return false
        }
      }
    },
    data() {
      return{
        personalEditorVisable: false,
        enterpriseEditorVisable: false,
        personalTabIndex: 'personal-basic-editor',
        enterpriseTabIndex: 'enterprise-editor',
      }
    },
    components: {
      'personal-basic-editor': () => import('./personal-basic-editor.vue'),
      'personal-extend-editor': () => import('./personal-extend-editor.vue'),
      'enterprise-editor': () => import('./enterprise-editor.vue'),
      'family-document-editor': () => import('./family-document-editor.vue'),
      'other-editor': () => import('./other-editor.vue'),
      'finance-editor': () => import('./finance-editor.vue'),
      'interest-editor': () => import('./interest-editor.vue'),
      'affairs-editor': () => import('./affairs-editor.vue'),
      'complaint-editor': () => import('./complaint-editor.vue'),
      'consultation-editor': () => import('./consultation-editor.vue'),
      'serve-editor': () => import('./serve-editor.vue'),
      'message-management-editor': () => import('./message-management-editor.vue'),
      'butler-note-editor': () => import('./butler-note-editor.vue'),
      'report-repairs': () => import('./report-repairs.vue'),
      'finance-list': () => import('./finance-list.vue'),
      'reason-list': () => import('./reason-list.vue'),
    },
    watch: {
      value(val) {
        if(val == true) {
          if(this.classValue == 1) {
            this.personalEditorVisable = true
          } else if(this.classValue == 2) {
            this.enterpriseEditorVisable = true
          }
        }
      },
      personalEditorVisable(val) {
        if(val == false) {
          this.$emit('input', val)
          this.personalTabIndex = 'personal-basic-editor'
        }
      },
      enterpriseEditorVisable(val) {
        if(val == false) {
          this.$emit('input', val)
          this.enterpriseTabIndex = 'enterprise-editor'
        }
      }
    },
    methods: {
      callback(arg) {
        this.$emit('callback', arg[0])
        if(this.classValue == 1 && this.id == 0) {
          this.personalTabIndex = 'personal-extend-editor'
        }
      }
    }
  }
</script>

<style lang="scss" scoped>

  @import "./common.scss";

</style>



// WEBPACK FOOTER //
// src/components/Admin/Customer/editor.vue